export function downloadText(filename: string, content: string, mime = "text/plain;charset=utf-8") {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

export function toCsv(rows: Array<Array<string | number | null | undefined>>): string {
  return rows
    .map((row) => row.map((value) => {
      const text = value == null ? "" : String(value);
      return /[";,\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
    }).join(";"))
    .join("\n");
}
